import { getBaseHost, getBookCover, isUrlHasHttpPart, makeResourceUrl } from "../url/url";
import {
  _makeMetaDataHTMLCommon,
  _makeMetaDataTwitterCommon,
  _makeMetaDataOpenGraphCommon
} from "./metaData.common";
import {makeItemMetaDataOpenGraph} from "./metaData.helpers";

const _fixBookMp3 = (bookMP3) => {
  if (isUrlHasHttpPart(bookMP3)) {
    return bookMP3;
  }
  return makeResourceUrl(bookMP3);
};

const _getImageUrlBook = (book) => {
  let url = getBookCover(book, true, true);

  if (!isUrlHasHttpPart(url)) {
    url = getBaseHost() + url;
  }

  return url;
};

const _getImageAltBook = (book) => {
  return "Cover of the book " + book.code;
};


const _makeMetaDataBook = (holderMetaData, book) => {
  return _makeMetaDataHTMLCommon(
    holderMetaData,
    book.title, book.description, book.code,
  );
};

/**
 * @param {MetaData} holderMetaData
 * @param {{}} book
 * @param {string} urlMp3
 * @param {string} urlPage
 * @returns {MetaData}
 * @private
 */
const _makeMetaDataOpenGraphBook = (
  holderMetaData,
  book, urlMp3, urlPage,
) => {
  _makeMetaDataOpenGraphCommon(
    holderMetaData,
    book.title, book.description,
    urlPage,
    _getImageUrlBook(book), _getImageAltBook(book),
  );

  holderMetaData.push(
    makeItemMetaDataOpenGraph("type", "book"),
    makeItemMetaDataOpenGraph("book:author", book.author),
    makeItemMetaDataOpenGraph("book:isbn", book.isbn),
    makeItemMetaDataOpenGraph("book:release_date", book.pub_year),
    makeItemMetaDataOpenGraph("book:tag", book.code),
  );

  if (urlMp3) {
    holderMetaData.push(makeItemMetaDataOpenGraph("audio", _fixBookMp3(urlMp3)));
  }

  return holderMetaData;
};

const _makeMetaDataTwitterBook = (holderMetaData, book) => {
  return _makeMetaDataTwitterCommon(
    holderMetaData,
    book.title, book.description,
    _getImageUrlBook(book), _getImageAltBook(book),
  );
};


/**
 * @param {MetaData} holderMetaData
 * @param {{}} book
 * @param {string} urlMp3
 * @param {string} urlPage
 * @returns {MetaData}
 */
export const makeMetaDataBook = (holderMetaData, book, urlMp3, urlPage) => {
  _makeMetaDataBook(holderMetaData, book);
  _makeMetaDataOpenGraphBook(holderMetaData, book, urlMp3, urlPage);
  _makeMetaDataTwitterBook(holderMetaData, book);
  return holderMetaData;
};
